import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Card, CardActions, CardContent, CardMedia, Chip, Grid, Stack, Typography, Tooltip, IconButton, Tab, Link, Rating, Avatar } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ApiService from '../../../../_services/ApiService';
import RatingReviewDialog from './RatingReviewDialog';
import { useSelector } from 'react-redux';
import SkeletonCard from '../../../../_helpers/reusablefunctions/SkeletonCard';
import NoResults from '../../../../components/reusableComponents/NoResults';
import { getStrPlatformImg } from '../../../../_helpers/reusablefunctions/getStreamingPlatform';
import Pagination from '../../../../_helpers/reusablefunctions/Pagination';
import { default_limit } from '../../../../_services/_constants/recordLimitset.constant';
import { getDateAsPerFormat } from '../../../../_helpers/reusablefunctions/dateSetter';
import defaultImage from '../../../../img/default-image.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import MusicNoteIcon from '@mui/icons-material/MusicNote';      // For Genre
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions'; // For Mood
import LanguageIcon from '@mui/icons-material/Language';        // For Language
import { useParams } from 'react-router-dom';

export default function MusicPlatforms() {
  const userData = useSelector((state) => state.userData.userData);
  const location = useLocation();
  const history = useHistory();
  const { songId } = useParams();
  const [singleSong, setGetSingleSong] = useState([]);
  const [relatedPlatfom, setRelatedPlatform] = useState([]);
  const [loader, setLoader] = useState({
    platform: true,
    review: true,
  })
  const [playlistId, setPlaylistId] = useState('')
  const [openRatingDialog, setOpenRatingDialog] = useState(false)
  const [hasPlatformClicks, setHasPlatformClicks] = useState(null);
  const [hasSongClicks, setHasSongClicks] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState()
  const [reviewList, setReviewList] = useState([])
  const [expanded, setExpanded] = useState({});

  const handleRouteBack = () => {
    // history.push('/discover-music')
    history.goBack();
  }

  function getSingleSong() {
    let dataObj = {}
    dataObj.search = songId;
    dataObj.user_id = userData.id;
    ApiService.get('getrelatedStreamingPlatforms', dataObj).then(res => {
      setLoader(prev => ({ ...prev, platform: false }))
      if (res.status === 200 || res.status === 201) {
        let arrayData = res.data.data;
        const data = arrayData.sort(function (a, b) {
          return parseInt(a.platform_order) - parseInt(b.platform_order);
        });
        setRelatedPlatform(data);
      }
    }).catch(error => {
      console.log(error)
    })
  }

  // Fetch analytics data for the song
  async function fetchSongAnalytics() {
    try {
      const songAnalytics = await ApiService.get('songAnalytics', { user: userData?.creator_auth }, songId);
      if (songAnalytics.status === 200 || songAnalytics.status === 201) {
        const clicks = songAnalytics.data?.data?.analytics?.events?.click || 0;
        setHasSongClicks(clicks);
      }
    } catch (error) {
      console.error('Error fetching song analytics:', error);
    }
  }

  // Fetch platform click counts
  const checkPlatformClicks = async () => {
    try {
      const platformIds = relatedPlatfom.map(p => p.id);

      const results = await Promise.allSettled(
        platformIds.map(id =>
          ApiService.get('platformAnalytics', { user: userData?.creator_auth }, id)
        )
      );
      const hasAnyClick = results.some(result => {
        if (result.status === 'fulfilled' && (result.value?.status === 200 || result.value?.status === 201)) {
          const clicks = result.value?.data?.data?.analytics?.events?.click || 0;
          return clicks;
        }
      });
      setHasPlatformClicks(hasAnyClick);
    } catch (error) {
      console.error('Unexpected error checking platform analytics:', error);
    }
  };
  useEffect(() => {
    if (relatedPlatfom?.length) {
      checkPlatformClicks();
    }
  }, [relatedPlatfom]);

  async function platformClickCount(id) {
    let user = {
      uid: userData?.creator_auth,
      platform: 'web'
    };
    try {
      const response = await ApiService.post('platformAnalytics', { user }, `${id}/click?revoke=false`);

      if (response.status === 200 || response.status === 201) {
        // Handle the response data as needed
        checkPlatformClicks();
        getSingleSongDetails()
        console.log('Platform Click Count:', response.data);
      }
    } catch (error) {
      console.error('Error fetching platform click count:', error);
    }
  }

  async function getSingleSongDetails() {
    try {
      const response = await ApiService.get('createSongList', { id: songId });
      if (response.status === 200 || response.status === 201) {
        setGetSingleSong(response.data.data[0]);
      }
    } catch (error) {
      console.error('Error fetching single song details:', error);
    }
  }

  // Fetch song details when the component mounts or when songId changes

  useEffect(() => {
    if (songId && singleSong.length === 0) {
      getSingleSongDetails();
    }
  }, [songId]);

  useEffect(() => {
    if (userData?.id) {
      getSingleSong()
      fetchSongAnalytics();
    }
  }, [userData])


  function openRatingHandler(id) {
    setOpenRatingDialog(true)
    setPlaylistId(id)
  }

  // Review and rating code
  const listApiCall = () => {
    ApiService.get('reviewSongList', { limit: rowsPerPage, offset: page }, songId).then(res => {
      const response = res?.data || []
      setLoader(prev => ({ ...prev, review: false }))
      if (response) {
        setReviewList(response?.results)
        setTotalCount(response?.total_count)
        getSingleSongDetails()
      }
    }).catch(error => {
      console.log('error')
    })
  }

  useEffect(() => {
    listApiCall();
  }, [page, rowsPerPage])

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 25);
    const newPage = Math.floor((page * rowsPerPage) / newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setPage(newPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const ReusableChipWithIcon = ({ icon, label, fallback = 'N/A' }) => {
    return (
      <Chip
        sx={{
          color: '#fff',
          borderColor: 'rgba(255,255,255,0.5)',
          '& .MuiChip-icon': {
            color: '#fff',
          },
        }}
        icon={icon}
        label={label || fallback}
        variant="outlined"
        size="small"
      />
    );
  };


  return (
    <Box sx={{ padding: '1rem 1rem 3rem 1rem', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box alignItems={'center'} display={'flex'} justifyContent={'space-between'} mb={3}>
        <Button className='gap-3 text-black' onClick={handleRouteBack}>
          <ArrowBackIcon /> {singleSong?.name || singleSong?.songTitle}
        </Button>
        <Typography variant="body2" className='border p-2'>
          Note: Please listen to the full song to enable the rating section.
        </Typography>
      </Box>

      <Grid container spacing={4} paddingLeft={2} paddingRight={2}>
        {/* Left Side - Song Card */}
        <Grid item xs={12} md={4}>
          <Card
            sx={{
              backgroundColor: '#F14950',
              color: 'white',
              borderRadius: '12px',
              overflow: 'hidden'
            }}
          >
            <Box display="flex" p={2}>
              <CardMedia
                component="img"
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '8px',
                  marginRight: 2
                }}
                image={
                  singleSong?.user_avatar
                    ? process.env.REACT_APP_BASEURL_MEDIA + 'media/' + singleSong.user_avatar
                    : singleSong?.songPoster300x300
                      ? singleSong?.songPoster300x300
                      : singleSong?.songPoster_url
                        ? singleSong.songPoster_url
                        : singleSong?.songPoster
                          ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + singleSong.songPoster
                          : singleSong?.cover_image
                            ? process.env.REACT_APP_SONGAPIURL_MEDIA + singleSong.cover_image
                            : defaultImage
                }
              />
              <Box flex={1}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                  {singleSong?.name || singleSong?.songTitle}
                </Typography>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <Typography variant="body2">
                    {singleSong?.artists || 'Unknown Artist'}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <Typography variant="body2">
                    {singleSong?.song_rating ? `${singleSong?.song_rating.average_rating}/5 (${singleSong?.song_rating?.rating_count} Rating)` : '0/5 (0 Rating)'}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1} mb={1} flexWrap="wrap">
                  <ReusableChipWithIcon
                    icon={<MusicNoteIcon />}
                    label={singleSong?.genre?.genre}
                    fallback="Unknown Genre"
                  />
                  <ReusableChipWithIcon
                    icon={<EmojiEmotionsIcon />}
                    label={singleSong?.mood?.mood}
                    fallback="Unknown Mood"
                  />
                  <ReusableChipWithIcon
                    icon={<LanguageIcon />}
                    label={singleSong?.language?.language}
                    fallback="Unknown Language"
                  />
                </Box>

              </Box>
            </Box>
          </Card>

          {/* Click to play section */}
          {relatedPlatfom.length > 0 && <Typography variant="h6" sx={{ mt: 3, mb: 2, fontWeight: 'bold' }}>
            Listen Songs
          </Typography>}

          <Stack spacing={1}>
            {loader.platform ? (
              Array.from(new Array(6)).map((item, index) => (
                <SkeletonCard key={index} />
              ))
              // ) : relatedPlatfom.length === 0 ? (
              //   <NoResults message="No Result Found" />
            ) : (
              relatedPlatfom.map((data, index) => {
                if (!data?.status) return null;

                const platformName = data?.streamingPlatformKey?.toLowerCase();
                const link = data?.streamingSonglink;
                const isSpotify = platformName == 'spotify';
                const isYouTube = platformName == 'youtube';


                const toggleEmbed = (id) => {
                  setExpanded((prev) => ({
                    ...prev,
                    [id]: !prev[id],
                  }));
                };

                const getSpotifyTrackId = (url) => {
                  const match = url?.match(/track\/([a-zA-Z0-9]+)/);
                  return match ? match[1] : '';
                };

                const getYouTubeVideoId = (url) => {
                  const match = url?.match(/(?:v=|\/embed\/|youtu\.be\/)([\w-]{11})/);
                  return match ? match[1] : '';
                };

                return (
                  <Box key={index} mb={2}>
                    <Box onClick={() => platformClickCount(data?.id)}>
                      <Link href={link} target="_blank" style={{ textDecoration: 'none' }}>
                        <Card
                          sx={{
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: '#f0f0f0' },
                            border: '1px solid #e0e0e0',
                            position: 'relative'
                          }}
                        >
                          <CardContent sx={{ padding: 1, paddingBottom: '10px !important' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                              <Box display="flex" alignItems="center" gap={2}>
                                <CardMedia
                                  component="img"
                                  sx={{ width: 32, height: 32, borderRadius: '50%' }}
                                  image={getStrPlatformImg(data?.streamingPlatformKey)}
                                />
                                <Typography variant="body1" sx={{ color: '#333' }}>
                                  {data?.streamingPlatformName}
                                </Typography>
                              </Box>

                              {/* Down arrow icon only for Spotify/YouTube */}
                              {/* {(isSpotify || isYouTube) && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleEmbed(data?.id);
                                  }}
                                >
                                  <ExpandMoreIcon />
                                </IconButton>
                              )} */}
                            </Box>
                          </CardContent>
                        </Card>
                      </Link>
                    </Box>

                    {/* Embed player toggle */}
                    {/* {expanded[data?.id] && (
                      <Box mt={1}>
                        {isSpotify && link && (
                          <iframe
                            src={`https://open.spotify.com/embed/track/${getSpotifyTrackId(link)}`}
                            width="100%"
                            height="80"
                            frameBorder="0"
                            allow="encrypted-media"
                            title={`Spotify Embed ${index}`}
                          ></iframe>
                        )}
                        {isYouTube && link && (
                          <iframe
                            width="100%"
                            height="315"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(link)}`}
                            title={`YouTube Embed ${index}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        )}
                      </Box>
                    )} */}
                  </Box>
                );
              })
            )}
          </Stack>
        </Grid>

        {/* Right Side - Rating and Reviews */}
        <Grid item xs={12} md={8}>
          <Box>
            {/* Rating Section */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
                Rating
              </Typography>
              <Tooltip title={(singleSong.userId !== userData?.id && !hasPlatformClicks) ? 'Hit play on your preferred platform, then come back to rate the song!'
                : singleSong.userId == userData?.id ? 'You cannot review or rate your own song' : ''} arrow>
                <span>
                  <Button
                    variant="outlined"
                    disabled={singleSong.userId == userData?.id }
                    onClick={() => singleSong.userId == userData?.id || !hasPlatformClicks ? null : openRatingHandler(singleSong.id)}
                    sx={{ borderColor: '#ff5757', color: '#ff5757' }}
                  >
                    Write a review ✏️
                  </Button>
                </span>
              </Tooltip>
            </Box>
            {/* Reviews */}
            <Box>
              {loader.review ?
                <Box className='Btn'>
                  {Array.from(new Array(8)).map((item, index) => (
                    <SkeletonCard />
                  ))}
                </Box>
                :
                loader.review === false && reviewList.length === 0 ? (
                  <NoResults message="No Reviews Found" />
                ) : reviewList.map((data) => (
                  <Card key={data.id} sx={{ mb: 2, border: '1px solid #e0e0e0' }}>
                    <CardContent>
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Box display="flex" alignItems="center" gap={2}>
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              borderRadius: '50%',
                              backgroundColor: '#ddd',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}
                          >
                            <Avatar
                              alt={data.user_name}
                              src={data?.user_avatar_url || process.env.REACT_APP_BASEURL_MEDIA + '/media/' + data.user_avatar}
                              sx={{ width: 30, height: 30 }}
                            />
                          </Box>
                          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                            {data.user_name}
                          </Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Rating
                            name="simple-controlled"
                            value={data.rating}
                            size="large"
                            sx={{
                              color: 'rgba(237, 28, 36, 1)',
                              '& .MuiRating-iconFilled': {
                                fontSize: '1.5rem',
                              },
                              '& .MuiRating-iconEmpty': {
                                fontSize: '1.5rem',
                              },
                            }}
                            readOnly
                          />
                          <Typography variant="body2" sx={{ color: '#666' }}>
                            {data?.rating} / 5
                          </Typography>
                        </Box>
                      </Box>

                      <Typography variant="body2" color="textSecondary" mb={2}>
                        {getDateAsPerFormat(data.created_at, "DD Mon, YYYY")}
                      </Typography>

                      <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                        {data.feedback}
                      </Typography>
                    </CardContent>
                  </Card>
                ))}
            </Box>
          </Box>

          <Pagination
            totalCount={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>

      <RatingReviewDialog
        dialogValue="Song"
        songId={playlistId}
        openRatingDialog={openRatingDialog}
        setOpenRatingDialog={setOpenRatingDialog}
        listApiCall={listApiCall}
      />
    </Box>
  )
}